import { SchedulerTheme, TimeSlot } from "./types/views";

const defaultWorkHours = { start: 9, end: 17 };

const isWorkHourSlot = (slot: TimeSlot) => {
  if (slot.isWeekend) {
    return "#f8fafc";
  }

  if (!slot.isWorkHour) {
    return "#f9fafb";
  }

  return "#ffffff";
};

export const defaultSchedulerTheme: SchedulerTheme = {
  eventTextColor: "#ffffff",
  eventDropTargetColor: "#eff6ff",
  getEventColor: (event) => {
    if (event.status === "completed") return "#16a34a";
    if (event.status === "in_progress") return "#ea580c";
    if (event.status === "cancelled") return "#6b7280";
    if (event.priority === "urgent" || event.priority === "high") return "#dc2626";
    return "#2563eb";
  },
  getEventHoverColor: (_event, baseColor) => baseColor,
  getGridCellColor: isWorkHourSlot,
  getWorkHours: () => defaultWorkHours,
};
